import { StepProvider } from "./Form/StepProvider";
import { StepReason } from "./Form/StepReason";
import { Progress } from "./Progress";
import { useFormStoreDatasContext } from "../../store/useFormStoreDatas";
import { useState } from "react";
import { Finish } from "./Form/Finish";
import { useCookieStoreContext } from "../../store/useCookieStore";
import { config } from "../../config";
import { SelectedOffer } from "./Form/SelectedOffer";
import { StepMainUse } from "./Form/StepMainUse";
import { Loader } from "./Form/Loader";

export const Hero = ({ }: {}) => {
    const { localStorageVariable, handleAcceptCookies, othersCookiesOptions } = useCookieStoreContext();
    const { formDatas, setFormDatas } = useFormStoreDatasContext();
    const [showStep, setShowStep] = useState<number>(1);
    const [progressGeneral, setProgressGeneral] = useState<number>(0);
    const [progressGeneral1, setProgressGeneral1] = useState<number>(0);
    const [progressGeneral2, setProgressGeneral2] = useState<number>(0);

    const handleSecondStep = (provider: string) => {
        setFormDatas((prev: any) => ({ ...prev, provider, currentOffer: "" }));
        if (localStorageVariable === null) {
            handleAcceptCookies();
        }
        setProgressGeneral(100);
        setShowStep(2);
    }

    const handleThirdStep = async (reason: string) => {
        setFormDatas((prev: any) => ({ ...prev, reason, lastname: "", firstname: "", phone: "" }));
        setProgressGeneral1(50);
        setShowStep(3);
    }

    const handleMainUse = async (usage: string) => {
        setFormDatas((prev: any) => ({ ...prev, usage }));
        setProgressGeneral1(100);
        setProgressGeneral2(100);
        setShowStep(4);
    }

    const handleLoader = async () => {
        setShowStep(6);
    }

    const lastStepFunction = async (preferredProvider: string, consentement: boolean) => {
        const updatedFormDatas = {
            ...formDatas,
            preferredProvider,
            consentement,
        };

        setFormDatas(updatedFormDatas);
        sendDatas(updatedFormDatas);
        setShowStep(5);
    }

    const getDataUtmTerm = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const term = searchParams.get('utm_term');
            if (term) {
                if (term.trim() !== '') {
                    return term;
                } else {
                    return 'Recherche Google';
                }
            } else {
                return "Recherche Google"
            }
        } else {
            return "Recherche Google"
        }
    }

    const getDataUtmOppy = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const oppy = searchParams.get('utm_oppy');
            if (oppy) {
                if (oppy.trim() !== '') {
                    return oppy;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataUtmCampaign = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const campaign = searchParams.get('utm_campaign');
            if (campaign) {
                if (campaign.trim() !== '') {
                    return campaign;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataGclid = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const gclid = searchParams.get('gclid');
            if (gclid) {
                if (gclid.trim() !== '') {
                    return gclid;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataHsaCam = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const hsa_cam = searchParams.get('hsa_cam');
            if (hsa_cam) {
                if (hsa_cam.trim() !== '') {
                    return hsa_cam;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataGadCampaignid = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const gad_campaignid = searchParams.get('gad_campaignid');
            if (gad_campaignid) {
                if (gad_campaignid.trim() !== '') {
                    return gad_campaignid;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataCampaignid = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const campaignid = searchParams.get('campaignid');
            if (campaignid) {
                if (campaignid.trim() !== '') {
                    return campaignid;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataUtmSource = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const utm_source = searchParams.get('utm_source');
            if (utm_source) {
                if (utm_source.trim() !== '') {
                    return utm_source;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataUtmMedium = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const utm_medium = searchParams.get('utm_medium');
            if (utm_medium) {
                if (utm_medium.trim() !== '') {
                    return utm_medium;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const getDataId = (name: string) => {
        if (name) {
            const objectUrl = new URL(name);
            const searchParams = new URLSearchParams(objectUrl.search);

            const id = searchParams.get('id');
            if (id) {
                if (id.trim() !== '') {
                    return id;
                } else {
                    return "";
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    const sendDatas = async (dataToSend: any) => {
        // const tel = parsePhoneNumberWithError(dataToSend.phone ?? '', 'FR');
        if (!Object.values(othersCookiesOptions).includes(false)) {
            if (config.gtag) {
                gtag('event', 'LeadCompleted');
            }
            if (config.microsoftAds && window.uetq) {
                window.uetq.push("event", "clicForm", {});
            }
        }
        const datas = {
            objectif: dataToSend.reason,
            currentOffer: dataToSend.currentOffer,
            choix_offre: 'Internet+TV',
            operateur_actuel: dataToSend.provider,
            fai_souhaite: dataToSend.preferredProvider,
            // lastname: dataToSend.lastname,
            // firstname: dataToSend.firstname,
            favoris: dataToSend.favoris,
            consentement: dataToSend.consentement,
            // phone: tel.number,
            subdomain: window.location.href ?? null,
            leadOrigin: import.meta.env.VITE_LEAD_ORIGIN ?? null,
            utmterm: getDataUtmTerm(window.location.href),
            utm_oppy: getDataUtmOppy(window.location.href),
            googleCampaignName: getDataUtmCampaign(window.location.href),
            googleLeadId: getDataGclid(window.location.href),
            hsa_cam: getDataHsaCam(window.location.href),
            gad_campaignid: getDataGadCampaignid(window.location.href),
            campaignid: getDataCampaignid(window.location.href),
            utm_source: getDataUtmSource(window.location.href),
            utm_medium: getDataUtmMedium(window.location.href),
            utm_campaign: getDataUtmCampaign(window.location.href),
            id: getDataId(window.location.href),
        }
        console.log("datas", datas);
        try {
            const response = await fetch(`${import.meta.env.VITE_COLLECT_API_BASE_URL}/flow-validation/039067e1-98a1-4bca-bd14-2a6119b9858f/execution`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(datas),
            });
            const data = await response.json();
            console.log("Response:", data);
        } catch (error) {
            console.error("Error sending data:", error);
        }
    }

    return (
        <>
            <div className="bg-secondaryNewComparateurFibre bg-header relative overflow-hidden lg:flex lg:justify-center">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    className="hidden lg:block absolute inset-0 w-full h-full object-cover z-0"
                    src="/animation_video.webm"
                />

                {showStep !== 4 && <div className="z-50 lg:bg-[#ffffffb3] lg:rounded-[30px] lg:shadow-[0_5px_15px_5px_rgba(0,0,0,0.05)] py-10 px-3 flex flex-col gap-6 lg:gap-0 max-w-7xl mx-auto lg:flex-row lg:items-center lg:justify-between lg:w-[95%] xl:w-full lg:px-0 lg:my-10">
                    <div className="text-[22px] md:text-[30px] lg:text-[26px] xl:text-[31px] lg:p-10 lg:leading-10 font-bold flex flex-col gap-2 md:w-[60%] lg:w-1/2 md:mx-auto">
                        <h1 className="bg-[#e2e1e1] lg:bg-[#f7f6f6] text-center md:text-left rounded p-1 md:p-2.5 lg:p-5 lg:rounded-xl">
                            Profitez d'une fibre et d'un forfait mobile à tarif réduit
                        </h1>
                        <div className="bg-orange-500 text-white text-center xl:text-left lg:text-[24px] xl:text-[26px] p-1 lg:p-5 lg:rounded-xl rounded">Demande rapide et sans engagement.
                        </div>
                    </div>


                    <div className="bg-[#ffffffb3] lg:bg-transparent shadow-[0_5px_15px_5px_rgba(0,0,0,0.05)] flex flex-col gap-6 p-5 lg:rounded-none lg:shadow-none rounded-[30px] md:w-[95%] lg:w-1/2 lg:h-auto md:mx-auto" id="top">
                        <div className="text-primaryNewComparateurFibre text-center text-5xl">La Fibre Facile</div>
                        <div className="bg-white border shadow-lg lg:shadow-none py-4 md:pt-2 rounded-[30px] md:w-[90%] md:mx-auto flex flex-col gap-6">
                            <Progress step={showStep} progressGeneral={progressGeneral} progressGeneral1={progressGeneral1} progressGeneral2={progressGeneral2} />
                            {(showStep === 1 && progressGeneral === 0) && <StepProvider handleSecondStep={handleSecondStep} />}
                            {(showStep === 2 && progressGeneral1 === 0) && <StepReason handleThirdStep={handleThirdStep} />}
                            {(showStep === 3 && progressGeneral1 === 50) && <StepMainUse handleMainUse={handleMainUse} />}
                            {(showStep === 5) && <Loader handleLoader={handleLoader} />}
                            {(showStep === 6) && <Finish />}
                        </div>
                    </div>
                </div>}

                {showStep === 4 && <div className="z-50 lg:bg-[#ffffffb3] lg:rounded-[30px] lg:shadow-[0_5px_15px_5px_rgba(0,0,0,0.05)] py-10 px-3 flex flex-col gap-6 lg:gap-0 max-w-7xl mx-auto lg:flex-row lg:items-center lg:justify-between lg:w-[95%] xl:w-full lg:px-0 lg:my-10">
                    <div className="bg-[#ffffffb3] lg:bg-transparent shadow-[0_5px_15px_5px_rgba(0,0,0,0.05)] flex flex-col gap-6 p-5 lg:rounded-none lg:shadow-none rounded-[30px] md:w-[95%] lg:w-full lg:h-auto md:mx-auto" id="top">
                        {(showStep === 4) && <SelectedOffer lastStepFunction={lastStepFunction} />}
                    </div>
                </div>}
            </div>
        </>
    );
};
